module.exports = __webpack_public_path__ + "images/bug_green_large_d98aca7f80e1572c6e16f0c10a62fe38.png";